import Radio from './Radio';
import withToggle from './withToggle';
import withInverse from './withInverse';
export default withInverse(withToggle(Radio));
//# sourceMappingURL=ToggleRadio.js.map